import React from 'react';
/* eslint-disable */
export function ConditionsFile(props: React.ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
      <path
        d="M2.33333 13.1667C1.96667 13.1667 1.65278 13.0361 1.39167 12.775C1.13056 12.5139 1 12.2 1 11.8333V3.83333C1 3.46667 1.13056 3.15278 1.39167 2.89167C1.65278 2.63056 1.96667 2.5 2.33333 2.5H6.33333L7.66667 3.83333H13C13.3667 3.83333 13.6806 3.96389 13.9417 4.225C14.2028 4.48611 14.3333 4.8 14.3333 5.16667H7.11667L5.78333 3.83333H2.33333V11.8333H7V13.1667H2.33333Z"
        fill="currentColor"
      />
      <path
        d="M10.9442 14.2437V12.9746H13.0558V14.2437H10.9442ZM9.25888 11.7563V10.4873H14.731V11.7563H9.25888ZM8 9.26904V8H16V9.26904H8Z"
        fill="currentColor"
      />
    </svg>
  );
}
